import { createContext, useContext, useMemo, useState } from 'react';

interface UserPreferencesContextValue {
    hideRelatedClauses: boolean;
    toggleHideRelatedClauses: () => void;
}

const UserPreferencesContext = createContext<UserPreferencesContextValue>({
    hideRelatedClauses: false,
    toggleHideRelatedClauses: () => {},
});

export const useUserPreferencesContext = () => {
    const context = useContext(UserPreferencesContext);
    return context;
};

interface ContractSearchProviderProps {
    children: React.ReactNode;
}

export const UserPreferencesProvider = ({
    children,
}: ContractSearchProviderProps) => {
    const [hideRelatedClauses, setHideRelatedClauses] = useState(false);

    const value = useMemo<UserPreferencesContextValue>(
        () => ({
            hideRelatedClauses,
            toggleHideRelatedClauses: () =>
                setHideRelatedClauses(!hideRelatedClauses),
        }),
        [hideRelatedClauses]
    );

    return (
        <UserPreferencesContext.Provider value={value}>
            {children}
        </UserPreferencesContext.Provider>
    );
};
